<template>
  <div
    :class="['x-date-filters', {'full-width': fullWidth }]"
    v-click-outside="() => showFilter = false"
  >
    <x-button
      :class="['input-field', 'md-raised', 'lighter', 'icon', { 'md-primary': showFilter, 'full-width': fullWidth }]"
      @click="showFilter = true"
    >
      <ic-calendar :color="showFilter ? colors.white : colors.daddy" />
      {{ selectedRangeLabel }}
    </x-button>

    <div
      v-if="showFilter"
      class="date-filters-wrapper"
    >
      <div
      :class="['date-filters-modal', { 'align-left': modalAlignLeft }]">
        <div class="calendar">
          <x-date-range-picker
            :defaultRange="dateRange"
            @changed="changed"
          >
          </x-date-range-picker>
        </div>

        <div class="buttons-container">
          <div
            v-if="$slots['additional-filter']"
            class="additional-filter"
          >
            <slot name="additional-filter"></slot>
          </div>

          <div class='range-selectors'>
            <x-button
              @click='setRange("last-month", $event)'
              :class='[
                "md-button", "button", "md-theme-default", "md-dense", "full-width",
                { "selected": predefinedRange === "last-month" }
              ]'
            >
              <span>{{ $t('advisory.customers-list.date-filters.last-month') }}</span>
            </x-button>
            <x-button
              @click='setRange("last-year")'
              :class='[
                "md-button", "button", "md-theme-default", "md-dense", "full-width",
                { "selected": predefinedRange === "last-year" }
              ]'
            >
              <span>{{ $t('advisory.customers-list.date-filters.last-year') }}</span>
            </x-button>
            <x-button
              @click='setRange("since-start")'
              :class='[
                "md-button", "button", "md-theme-default", "md-dense", "full-width",
                { "selected": predefinedRange === "since-start" }
              ]'
            >
              <span>{{ $t('advisory.customers-list.date-filters.since-start') }}</span>
            </x-button>
          </div>

          <div class="actions">
            <x-button
              @click='submit'
              class='md-button button md-theme-default md-raised md-primary'
              :disabled='!isValidRange'
            >
              <span>{{ $t('buttons.apply') }}</span>
            </x-button>
            <x-button
              @click='reset'
              class='md-button button md-theme-default md-flat md-secondary reset'
            >
              <span>{{ $t('buttons.reset') }}</span>
            </x-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import vClickOutside from 'v-click-outside'
  import icCalendar from '@/svg/ic-calendar'
  import * as colors from '@/colors'

  export default {
    name: 'x-date-filters',

    props: {
      defaultRange: {
        type: Array,
        default: null
      },
      fullWidth: {
        type: Boolean,
        default: false
      },
      modalAlignLeft: {
        type: Boolean,
        default: false
      }
    },

    components: {
      icCalendar
    },

    directives: {
      clickOutside: vClickOutside.directive
    },

    data () {
      return {
        colors: colors,
        showFilter: false,
        dateRange: this.defaultRange,
        predefinedRange: null,
        dateFormat: 'YYYY-MM-DD',
        startDate: null,
        endDate: null
      }
    },

    computed: {
      isValidRange () {
        return Boolean(this.dateRange && this.dateRange.length === 2)
      },

      selectedRangeLabel () {
        if (this.defaultRange[0] && this.defaultRange[1]) {
          const x = this.$moment(this.defaultRange[0]).format('DD.MM.YYYY')
          const y = this.$moment(this.defaultRange[1]).format('DD.MM.YYYY')
          return (x + ' - ' + y)
        } else {
          return this.$t('buttons.date-filter')
        }
      }
    },

    methods: {
      submit () {
        this.showFilter = false

        if (!this.startDate && !this.endDate && this.dateRange !== null) {
          this.startDate = this.dateRange[0]
          this.endDate = this.dateRange[1]
        }
        this.$emit('change-filters', { startDate: this.startDate, endDate: this.endDate })
      },

      changed (newDates) {
        this.predefinedRange = null
        this.updateFilters(newDates)
      },

      updateFilters (newDates) {
        this.dateRange = newDates
        this.startDate = this.$moment(newDates[0]).format(this.dateFormat)
        this.endDate = this.$moment(newDates[1]).format(this.dateFormat)
      },

      reset () {
        this.dateRange = null
        this.startDate = null
        this.endDate = null

        this.submit()
      },

      setRange (val) {
        this.predefinedRange = val

        let min = null
        let max = this.$moment(new Date())
        switch (val) {
          case 'last-month':
            min = this.$moment(new Date()).subtract(1, 'month')
            break
          case 'last-year':
            min = this.$moment(new Date()).subtract(1, 'year')
            break
          case 'since-start':
            // Chosen arbitrarily as this date does not exist in API
            min = this.$moment('2017-01-01')
            break
        }

        this.updateFilters([ min.toDate(), max.toDate() ])
      }
    }
  }
</script>

<style lang='scss' scoped rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .x-date-filters {
    &.full-width {
      width: 100%;
    }

    @media screen and (max-width: $small-breakpoint) {
      width: 100%;
    }

    .input-field {
      @media screen and (max-width: $small-breakpoint) {
        width: 100%;
      }

      &.lighter {
        background-color: #EBEDF8;
        color: $color-daddy;
      }

      /deep/ .md-ripple {
        justify-content: left;
      }

      /deep/ svg {
        margin: auto 0.5rem;
      }
    }
  }

  .date-filters-wrapper {
    position: relative;
    width: 100%;
    z-index: 9;
    background: white;

    .date-filters-modal {
      background-color: white;
      box-shadow: 0 5px 18px 0 rgba(150,163,184,0.8);
      position: absolute;
      width: auto;
      right: 0;
      top: 1rem;
      display: flex;

      &.align-left {
        left: 0;
        right: auto;

        @media screen and (max-width: $small-breakpoint) {
          left: 50%;
        }
      }

      @media screen and (max-width: $small-breakpoint) {
        display: block;
        left: 50%;
        right: auto;
        transform: translateX(-50%);
      }

      .calendar {
        padding: 2rem;
      }

      .buttons-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 2rem 2rem 2rem 1rem;

        @media screen and (max-width: $small-breakpoint) {
          padding: 0 2rem 2rem 2rem;
        }

        .additional-filter {
          @media screen and (max-width: $small-breakpoint) {
            margin-bottom: 2rem;
          }
        }

        .range-selectors {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;

          @media screen and (max-width: $small-breakpoint) {
            padding-bottom: 2rem;
          }

          .button {
            margin: 0.5rem 0;
            background-color: rgba(#EBEDF8, 0.4);
            color: $color-daddy;
            font-weight: 600;

            &.selected {
              background-color: rgba(map_get($palette-primary, main), 0.12);
              color: map_get($palette-primary, main);
            }
          }
        }

        .actions {
          display: flex;

          .button {
            width: 48%;
            font-weight: 600;
            margin: 0 1%;
          }

          .reset {
            color: $color-daddy;
          }
        }
      }

      /deep/ .x-date-picker .flatpickr-calendar {
        margin: auto;
      }
    }
  }
</style>
